import { render, staticRenderFns } from "./JobProfitability.vue?vue&type=template&id=b66275d2"
import script from "./JobProfitability.vue?vue&type=script&lang=js"
export * from "./JobProfitability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports